<template>
  <v-layout row>
    <Menu/>
    <v-flex row xs12>
      <v-flex style="background-color:silver" xs3>
        <v-layout row wrap style="padding-left:40px;">
          <v-flex style="height:100vh" xs11>
            <v-card style="height:100%" color=" darken-2" class="white--text">
              <v-card-title primary-title>
                <div>
                  
                    <img
                      src="@/assets/Art/HowToAddUSers.svg"
                      height="84%"
                      
                      style="position:absolute;left:30px;top:40px;margin-left:0px;cursor:pointer; "
                    >
                  
                </div>
                <a style="margin: 20px auto" href="https://medium.com/@lachlangreenbank/how-to-add-your-apps-user-base-to-smartpress-7c5f90c52968" target="_blank">
                  <v-btn outline large color="green" >start</v-btn>
                </a>
              </v-card-title>
              
                <!-- <v-spacer/>
                <v-text-field placeholder="mate@gmail.com" style="margin:10px" dark email v-model="inviteEmailBox"></v-text-field>
                <v-btn @click="email()" outline dark><icon color="white">account_circle</icon>Send invite</v-btn>
                -->
            </v-card>
          </v-flex>

          <!-- <v-flex style="height:50vh" xs11>
            <v-card style="height:100%" color="green darken-3" class="white--text">
              <v-layout>
                <v-flex xs12>
                  <div style="margin:14px;" class="headline">...Or create users with our API</div>

                  <v-card-actions v-show="!apiInfoShow">
                    <v-spacer/>
                    <v-btn  to="/docs" @click="apiInfoShow = true" outline dark><icon color="white">account_circle</icon>Docs</v-btn>
                  </v-card-actions>
                  <span v-show="apiInfoShow">
                    <v-card-title primary-title>
                      <div>
                        
                        <div style="margin-bottom:20px;"><strong>endpoint:</strong> smart.press/api/ *USER_ID* /newUser</div>

                        <div style="margin-bottom:20px;"><strong>Request type:</strong> POST</div>
                        <div><strong>Response data:</strong> {username: 'account_name'}</div>
                      </div>
                    </v-card-title>
                    <v-card-actions>
                      <v-spacer/>
                      <v-btn outline dark><icon color="white">account_circle</icon>Docs</v-btn>
                    </v-card-actions>
                  </span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex> -->
        </v-layout> 
      </v-flex>
      <v-flex xs9>
       <v-card>
        <v-toolbar flat color="blue" dark>
<!--           <v-toolbar-side-icon></v-toolbar-side-icon>
 -->
          <v-toolbar-title>Invitations</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- <v-btn icon>
            <v-icon>search</v-icon>
          </v-btn> -->
        </v-toolbar>

        <v-list two-line>
          <template v-for="(item, index) in myUsers.Items">
            <v-subheader
              v-if="item.header"
              :key="item.header"
            >
              {{ item.invited_email.S }}
            </v-subheader>

       

            <v-list-tile
              v-else
              :key="item.invite_id.S"
              avatar
              @click=""
            >
              <v-list-tile-avatar>
                <v-icon>person</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.invited_email.S }}
                </v-list-tile-title>

                <v-list-tile-sub-title>
                  <v-layout>
                    <v-flex xs3>status: {{ item.status.S }}</v-flex>
<!--                     <v-flex xs3>fdsa</v-flex>
                    <v-flex xs3>asdf</v-flex>
                    <v-flex xs3>fdsa</v-flex> -->
                  </v-layout>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          

          <v-toolbar flat color="cyan" dark>
<!--           <v-toolbar-side-icon></v-toolbar-side-icon>
 -->
          <v-toolbar-title>Users</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- <v-btn icon>
            <v-icon>search</v-icon>
          </v-btn> -->
        </v-toolbar>
        <template v-if="!myProjectsAccounts.Items">
 

            <v-list-tile
      
             
              avatar
              
            >
              <v-list-tile-avatar>
                <v-icon>person</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                 

                <v-list-tile-sub-title>
                  <v-layout>
                    <v-flex xs3>Go create some users, <strong>Invite by email or</strong> <v-btn small to="docs">Add users with our API</v-btn></v-flex>
<!--                     <v-flex xs3>fdsa</v-flex>
                    <v-flex xs3>asdf</v-flex>
                    <v-flex xs3>fdsa</v-flex> -->
                  </v-layout>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
          <template v-for="(item, index) in myProjectsAccounts.Items">
            <v-subheader
              v-if="item.header"
              :key="item.header"
            >
              {{ item.user_id.S }}
            </v-subheader>

       

            <v-list-tile
              v-else
              :key="item.account_name.S"
              avatar
              
            >
              <v-list-tile-avatar>
                <v-icon>person</v-icon>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>
                  EOSIO address: {{ item.account_name.S }}
                </v-list-tile-title>

                <v-list-tile-sub-title>
                  <v-layout>
                    <v-flex xs3>user_id: {{ item.user_id.S }}</v-flex>
<!--                     <v-flex xs3>fdsa</v-flex>
                    <v-flex xs3>asdf</v-flex>
                    <v-flex xs3>fdsa</v-flex> -->
                  </v-layout>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>
        </v-list>
      </v-card>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
  import store from "@/store"
  import Menu  from '../components/Menu'
  import { mapState } from 'vuex'
  export default {
      components:{
        Menu
      },
      methods: {
        email: function  () {
          this.$store.dispatch('contractsDb/email', {
            invited_email: this.inviteEmailBox
          })
          this.inviteEmailBox = ''
        }
      },
      created: function () {
        this.$store.dispatch('contractsDb/getMyUsers')
        this.$store.dispatch('contractsDb/getMyProjectsAccounts')
      },

      computed: {
        ...mapState({
          myUsers: state => state.contractsDb.myUsers,
          myProjectsAccounts: state => state.contractsDb.myProjectsAccounts
        }),
      },
      data () {
      return {
        inviteEmailBox: '',
        apiInfoShow: false,
          
      }
    }
  }
</script>

